export default __webpack_public_path__ + "static/media/step1Plwd.c1699f8b.png";